import React from 'react';
import { Bot } from 'lucide-react';

/**
 * 메시지가 없을 때 표시되는 환영 화면 컴포넌트.
 */
const ChatEmptyState = ({ userName }) => {
    return (
        <div className="flex-1 flex flex-col items-center justify-start min-h-0 text-center pt-10 sm:pt-16 px-4">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-4 shadow-sm shrink-0">
                <Bot size={28} className="sm:w-8 sm:h-8" />
            </div>
            <h2 className="text-xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-3 tracking-tight leading-snug">
                안녕하세요, {userName}님!<br />무엇을 도와드릴까요?
            </h2>
            <p className="text-gray-400 text-sm sm:text-base max-w-[260px] sm:max-w-sm">
                산업안전보건법 및 관련 규정에 대해<br />궁금한 점을 자유롭게 물어보세요.
            </p>
        </div>
    );
};

export default ChatEmptyState;
